<script>
import { h, Fragment } from 'vue';
import { debounce } from 'lodash';
import BaseContainer from '@/components/base/Container';

function unwrapFragments(els) {
  return els.reduce((acc, child) => {
    if (child.type === Fragment) {
      acc.push(...unwrapFragments(child.children));
    } else {
      acc.push(child);
    }

    return acc;
  }, []);
}

export default {
  components: {
    BaseContainer,
  },
  props: {
    cars: {
      type: Array,
      default: () => [],
    },
    hasBorders: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      perRow: 3,
    };
  },
  created() {
    this.updatePerRowDebounced = debounce(this.updatePerRow, 200);
  },
  mounted() {
    window.addEventListener('resize', this.updatePerRowDebounced);
    this.updatePerRowDebounced();
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.updatePerRowDebounced);
  },
  methods: {
    updatePerRow() {
      if (window.innerWidth <= 1200) {
        this.perRow = 2;
      } else {
        this.perRow = 3;
      }
    },
  },
  render() {
    const slotContent = this.$slots.default?.();
    const unwrappedContent = unwrapFragments(slotContent);
    const wrappedCards = unwrappedContent.map((el) => h(
      'div',
      {
        class: this.$style.cardWrapper,
      },
      el,
    ));

    const extraCards = wrappedCards.length % this.perRow;

    const cardsWithFillers = [
      ...wrappedCards,
      ...new Array(extraCards ? (this.perRow - extraCards) : 0).fill(h(
        'div',
        {
          class: this.$style.cardWrapper,
        },
      )),
    ];

    return h(
      BaseContainer,
      {
        isPaddingless: true,
      },
      () => h(
        'div',
        {
          class: [
            this.$style.cards,
            { [this.$style.hasBorders]: this.hasBorders },
          ],
        },
        cardsWithFillers,
      ),
    );
  },
};
</script>

<style lang="scss" module>
@mixin draw-grid($perRow) {

  &:nth-child(#{$perRow}n + #{$perRow + 1}) {

    &::after {
      position: absolute;
      top: -1px;
      left: -40px;
      display: inline-block;
      width: 40px;
      height: 1px;
      content: '';
      background: rgba($disabled, 0.4);
    }
  }

  &:nth-child(#{$perRow}n + #{$perRow * 2}) {

    &::after {
      position: absolute;
      top: -1px;
      right: -40px;
      display: inline-block;
      width: 40px;
      height: 1px;
      content: '';
      background: rgba($disabled, 0.4);
    }
  }

  &:nth-child(1n + #{$perRow + 1}) {
    border-top: 1px solid rgba($disabled, 0.4);
  }

  &:not(:nth-child(#{$perRow}n)) {
    border-right: 1px solid rgba($disabled, 0.4);
  }
}

.cards {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  padding: 0 40px;

  @media screen and (max-width: 1200px) {
    grid-template-columns: 1fr 1fr;
  }

  &.hasBorders {

    .cardWrapper {
      @media screen and (max-width: 1200px) {
        @include draw-grid(2);
      }

      @media screen and (min-width: 1201px) {
        @include draw-grid(3);
      }
    }
  }
}

.cardWrapper {
  position: relative;
}
</style>
